<template>
  <v-btn
    color="primary"
    data-cy="btn_enviar"
    :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
    :disabled="desabilitarBtn"
    :loading="botaoLoading"
    @click="enviarSolicitacaoReembolso"
  >
    Enviar
  </v-btn>
</template>

<script>

import api from '@/api';
import { mapGetters } from 'vuex';
import { sanitizeCpfCnpj } from '@/utils/cpfCnpj';

export default {
  name: 'BtnEnviar',

  props: {
    dadosReembolso: {
      type: Object,
      required: true,
    },
    anexos: {
      type: Array,
      default: () => [],
    },
    desabilitarBtn: {
      type: Boolean,
      required: true,
    },
    urlApi: {
      type: String,
      default: '/refund-request',
    },
    isCorrigirDados: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dados: {},
      formdata: null,
      botaoLoading: false,
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),
  },

  watch: {
    dadosReembolso: {
      handler() {
        this.montarObjeto();
      },
      deep: true,
    },
    anexos: {
      handler() {
        this.montarObjeto();
      },
      deep: true,
    },
  },

  methods: {
    enviarSolicitacaoReembolso() {
      this.botaoLoading = true;
      this.enviaRespostaApi();
    },
    async enviaRespostaApi() {
      let response = '';
      try {
        if (this.isCorrigirDados) {
          response = await api.post(this.urlApi, this.formdata, {
            params: {
              order: this.dadosCompra.venda,
            },
          });
        } else {
          response = await api.post(this.urlApi, this.formdata);
        }
        this.$emit('respostaApi', response.data.success);
      } catch (error) {
        this.$emit('respostaApi', false);
      } finally {
        this.botaoLoading = false;
      }
    },

    montarObjeto() {
      if (Object.keys(this.dadosReembolso).length > 0) {
        const formdata = new FormData();
        formdata.append('order', this.dadosReembolso.venda);

        const isBoleto = this.dadosReembolso.is_boleto;
        const isDebitCard = this.dadosReembolso.is_debit_card;
        const isDebitoOnline = this.dadosReembolso.is_online_debt;
        const isBoletoParcelado = this.dadosCompra.is_boleto_in_installments;
        const sendBankInfo = isBoleto || isDebitoOnline || isBoletoParcelado || isDebitCard;
        if (sendBankInfo) {
          formdata.append('full_name', this.dadosReembolso.nomeFavorecido);
          formdata.append('federal_tax_number', sanitizeCpfCnpj(this.dadosReembolso.fieldCpfCnpj));
          formdata.append('bank_code', this.dadosReembolso.bankCode);
          formdata.append('account_type', this.dadosReembolso.tipoConta);
          formdata.append('bank_branch', this.tratarValorNulo(this.dadosReembolso.agencyNumber));
          formdata.append('bank_branch_suffix', this.tratarValorNulo(this.dadosReembolso.agencyCheckNumber));
          formdata.append('account_number', this.tratarValorNulo(this.dadosReembolso.accountNumber));
          formdata.append('account_number_suffix', this.tratarValorNulo(this.dadosReembolso.accountCheckNumber));
          formdata.append('operation_type', this.tratarValorNulo(this.dadosReembolso.operacaoVariacao));
          formdata.append('accepted_terms', this.dadosReembolso.accepted_terms ? 1 : 0);
        }

        if (!this.isCorrigirDados) {
          formdata.append('category', this.dadosReembolso.category_reembolso);
          formdata.append('comments', this.dadosReembolso.observacoes);

          for (let i = 0; i < this.anexos.length; i++) {
            formdata.append(`file${i}`, this.anexos[i]);
          }
        }

        this.formdata = formdata;
      }
    },

    tratarValorNulo($data) {
      return $data == null ? '' : $data;
    },
  },
};
</script>
